export enum UM_INTEGRATIONS {
	AuthAIFloridaBlue = 'AuthAIFloridaBlue',
}